import axios from 'axios'
import store from '../../../store'

class API {
  constructor () {
    this.config = store.getState().configReducer
    store.subscribe(() => {
      this.config = store.getState().configReducer
    })
    this.site = store.getState().siteReducer
    // Hack to load login into store since we do not have control over the store loading
    this.loadLogin()
    store.subscribe(() => {
      this.site = store.getState().siteReducer
      this.saveLogin()
    })
  }

  loadLogin () {
    try {
      let user = window.localStorage.getItem('flowaccess_installation_auth')
      if (!user) return
      user = JSON.parse(user)
      if (this.site.username !== user.username || this.site.password !== user.password) {
        store.dispatch({
          type: 'SET_BASIC_AUTH',
          payload: {
            username: user.username,
            password: user.password
          }
        })
        console.debug('Load login information')
      }
    } catch (e) {
      // ignored
    }
  }

  saveLogin () {
    try {
      window.localStorage.setItem('flowaccess_installation_auth', JSON.stringify({
        username: this.state.username,
        password: this.state.password
      }))
      console.debug('Saved login information')
    } catch (e) {
      // ignored
    }
  }

  logout () {
    try {
      window.localStorage.removeItem('flowaccess_installation_auth')
    } catch (e) {
      // ignored
    }
    store.dispatch({
      type: 'SET_BASIC_AUTH',
      payload: {
        username: undefined,
        password: undefined
      }
    })
    this.saveLogin()
  }

  login (endpoint, username, password) {
    return new Promise((resolve, reject) => {
      axios.request(
        {
          url: this.config.api_base + endpoint,
          method: 'get',
          auth: {username: username, password: password},
          headers: {
            'Cache-Control': 'no-cache'
          }
        }
      ).then((res) => {
        resolve(res)
        store.dispatch({
          type: 'SET_BASIC_AUTH',
          payload: {
            username: username,
            password: password
          }
        })
      }).catch(result => {
        API.handleError(result)
        reject(result)
      })
    })
  }
  getNoErrorHandling (endpoint, params, options) {
    return new Promise((resolve, reject) => {
      axios.request(
        {
          // params: {...params, ts: Date.now()},
          params: {...params},
          url: this.config.api_base + endpoint,
          method: 'get',
          auth: {username: this.site.username, password: this.site.password},
          headers: {
            'Cache-Control': 'no-cache'
          },
          ...options
        }
      ).then(res => {
        resolve(res)
      }).catch(result => {
        reject(result)
      })
    })
  }

  get (endpoint, params, options) {
    return new Promise((resolve, reject) => {
      axios.request(
        {
          // params: {...params, ts: Date.now()},
          params: {...params},
          url: this.config.api_base + endpoint,
          method: 'get',
          auth: {username: this.site.username, password: this.site.password},
          headers: {
            'Cache-Control': 'no-cache'
          },
          ...options
        }
      ).then(res => {
        resolve(res)
      }).catch(result => {
        if (result.response !== undefined && result.response.status === 404) {
          resolve(result)
        } else {
          API.handleError(result)
          reject(result)
        }
      })
    })
  }

  static handleError (result) {
    console.log('Got error ', result)
    console.dir(result)
    let cause, title
    if (result.response === undefined) {
      title = 'Network error'
      cause = 'The server is currently unavailable, try again later.'
    } else if (result.response.data && result.response.data.cause) {
      title = API.getTitle(result.response.status)
      cause = result.response.data.cause
    } else {
      title = API.getTitle(result.response.status)
      cause = ''
    }
    store.dispatch({
      type: 'ALERT_CREATE',
      payload: {
        title: title,
        type: 'error',
        text: cause
      }
    })
  }

  static getTitle (httpcode) {
    switch (httpcode) {
      case 400:
        return 'Bad request'
      case 401:
        return 'Unauthorized'
      case 405:
        return 'Method not allowed'
      case 500:
        return 'Internal error'
      case 501:
        return 'Not implemented'
      default:
        return '' + httpcode
    }
  }
}

export default new API()



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/API/API.js